//import { formatJsonLocation as fjl, formatLocation } from "../../components/renderers";
import { formatJsonLocation as fjl } from "../../components/renderers";
import { formatJsonDataset as fjd } from "../../components/renderers";

//const xlsaccept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

export const inspectionconfig = {

  // inspector: {
  //   service: {
  //     name: 'inspector',
  //     title: 'Inspector',
  //     key: 'rid',
  //     num: true,
  //     fields:['rid','nam','usk','usi','unm','eni','ens','enc','iti','itc','iri','irc','sci','scc','mbn','eml','des','dsc','dcd','exi','sts','ast','stp'],
  //     params: {nam:'Name',shc:'Code',dsc:'Description',usi:'User',iti:'Monitor Type',iri:'Inspector Role',sci:'Sector',sts:'Status'},
  //     grid: [['nam','Name'],['mbn','Phone'],['eml','Email'],['itc','Type'],['des','Designation'],['enc','Entity'],['ast','Status'],['stp','Stamp']],
  // 	  bar: {pag:true,btn:['view']},
  //     menu: {mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
  //     eform:[
  //           {id:'iti',label:'Inspector Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'inspectortype'},chs:['nam','usi']},
  //           {id:'nam',label:'Name',type:'tf',req:0,ops:{},pns:['iti']},
  //           {id:'usi',label:'User',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'user'}},
  //           {id:'iri',label:'Inspector Role',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'inspectorrole'}},
  //           {id:'sci',label:'Sector',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'sector'}},
  //           {id:'mbn',label:'Mobile',type:'ta',req:1,ops:{type:'tel'}},
  //           {id:'eml',label:'Email',type:'tf',req:1,ops:{type:'email'},},
  //           {id:'des',label:'Designation',type:'tf',req:0,ops:{}},
  //           {id:'dsc',label:'Description',type:'tf',req:0,ops:{}},
  //           {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
  //           {id:'sts',label:'Record Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}},
  //         ],
  //   },
  //   create:true,
  //   actions: {add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
  //   panels: {add:'simple',edit:'simple',delete:'dialog',view:'simple'},
  //   formatters: {grid: {exi:fjd}}
  // },

  monitoring: {
    //fieldTypes: {tf:'',ta:'',nf:'',df:'',cf:'',rf:'',cb:'',fa:'',rb:'',if:'',ff:''},
    service: {
      name: 'monitoring',
      title: 'Monitoring',
      key: 'rid',
      num: false,
      fields: ['rid', 'ttl', 'sch', 'rfn', 'eni', 'ens', 'enc', 'etc', 'nsi', 'nsk', 'nsn', 'nsu', 'nsr', 'sts', 'ast', 'stp'],
      grid: [['ttl', 'Title'], ['tmn', 'Team'], ['lcc', 'Location'], ['smr', 'Summary'], ['prc', 'Priority'], ['rlc', 'Risk Level'], ['dat', 'Due'], ['ssc', 'State'], ['stp', 'Stamp']],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' }, { t: 'Code', v: 'shc' }], def: 'nam' },
      eform: [
        { id: 'ttl', label: 'Title', type: 'tf', req: 1, ops: {} },
        // {id:'shc',label:'Shortcode',type:'tf',req:0,ops:{}},
        { id: 'eni', label: 'Entity', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'entity' }, chs: ['lci'] },
        { id: 'tmi', label: 'Team', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'team' } },
        { id: 'iti', label: 'Monitoring Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'monitoringtype' } },
        { id: 'lci', label: 'Location', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'inspectionlocation' }, pns: ['eni'] },
        { id: 'smr', label: 'Summary', type: 'tf', req: 1, ops: {}, },
        { id: 'dat', label: 'Due Date', type: 'df', req: 1, ops: {} },
        { id: 'pri', label: 'Priority', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'monitoringpriority' } },
        { id: 'rli', label: 'Risk Level', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'monitoringrisklevel' } },
        { id: 'sti', label: 'Monitoring State', type: 'fa', req: 0, ops: {}, cp: { t: 'bcs', s: 'monitoringstate' } },
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
      ],
    },
    create: true,
    //actions: {add:'Add',view:'View'},
    //panels: {add:'simple',view:'simple'}
    actions: { add: 'Add', edit: 'Edit', delete: 'Delete', view: 'View', process: 'Process' },
    panels: { add: 'wizard', edit: 'simple', delete: 'dialog', view: 'simple', process: 'wizard' },
    formatters: { grid: { exi: fjd } }
  },

  item: {
    service: {
      name: 'item',
      title: 'Item',
      fields: ['rid', 'nam', 'cti', 'ctn', 'ctc', 'iti', 'itn', 'itc', 'idn', 'mbn', 'eml', 'dsc', 'exi', 'sts', 'ast', 'stp'],
      grid: [['ttl', 'Monitoring'], ['qnc', 'Group'], ['qnn', 'Question'], ['stc', 'State'],
        ['sts', 'Status'], ['stp', 'Stamp']],
      menu: { mnu: [{ t: 'Customer', v: 'nam' }, { t: 'Code', v: 'shc' }], def: 'nam' },
      eform: [{ id: 'iti', label: 'Monitoring', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'monitoring' } },
        { id: 'qni', label: 'Question', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'itemquestion' } },
        { id: 'sti', label: 'Item State', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'itemstate' } },
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }
  },

  itemquestion: {
    service: {
      name: 'itemquestion',
      title: 'Item Question',
      fields: ['rid', 'nam', 'cti', 'ctn', 'ctc', 'iti', 'itn', 'itc', 'idn', 'mbn', 'eml', 'dsc', 'exi', 'sts', 'ast', 'stp'],
      grid: [['nam', 'Question'], ['shc', 'Code'], ['itc', 'Item type'], ['sts', 'Status'], ['stp', 'Stamp']],
      menu: { mnu: [{ t: 'Customer', v: 'nam' }, { t: 'Code', v: 'shc' }], def: 'nam' },
      eform: [{ id: 'nam', label: 'Question', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Short Code', type: 'tf', req: 1, ops: {} },
        { id: 'iti', label: 'Item Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'itemtype' } },
        { id: 'sts', label: 'Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }
  },

  finding: {
    service: {
      name: 'finding',
      title: 'Finding',
      key: 'rid',
      num: false,
      fields: ['rid', 'dvn', 'dvk', 'dvc', 'dvm', 'dsc', 'dti', 'dtn', 'dtc', 'eni', 'enm', 'enc', 'lci', 'lcn', 'lcc', 'geo', 'dcd', 'exi', 'sts', 'ast', 'stp'],
      params: { dvn: 'Name', dvk: 'Devicekey', dvc: 'Devicecode', dvm: 'Devicemask', dsc: 'Description', dti: 'Type', eni: 'Entity', lci: 'Location', dcd: 'Created', geo: 'Geocode', exi: 'Extrainfo', sts: 'Status' },
      grid: [['ttl', 'Title'], ['inr', 'Reference'], ['dsc', 'Description'], ['inc', 'Monitoring'], ['svc', 'Severity'], ['vic', 'Violation'], ['fsc', 'State'], ['dcd', 'Created']],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'dvn' }, { t: 'Code', v: 'shc' }], def: 'nam' },
      eform: [{ id: 'ttl', label: 'Title', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'ini', label: 'Monitoring', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'monitoring' } },
        { id: 'vii', label: 'Violation', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'violation' } },
        { id: 'svi', label: 'Severity', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'severity' } },
        { id: 'fsi', label: 'Finding State', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'findingstate' } },
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
      ],
    },
    create: false,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { geo: fjl, exi: fjd } }
  },

  teammember: {
    service: {
      name: 'teammember',
      title: 'Team Member',
      key: 'rid',
      num: false,
      fields: ['rid', 'dvn', 'dvk', 'dvc', 'dvm', 'dsc', 'dti', 'dtn', 'dtc', 'eni', 'enm', 'enc', 'lci', 'lcn', 'lcc', 'geo', 'dcd', 'exi', 'sts', 'ast', 'stp'],
      params: { tsc: 'Team', mnm: 'Member', rsc: 'Team Role', dsc: 'Description', exi: 'Extrainfo', sts: 'Status' },
      grid: [['tnm', 'Team'], ['mnm', 'Member'], ['rsc', 'Team Member Role'], ['dsc', 'Description'], ['stp', 'Created']],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'dvn' }, { t: 'Code', v: 'shc' }], def: 'nam' },
      eform: [{ id: 'tid', label: 'Team', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'team' } },
        { id: 'mid', label: 'Member', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'monitor' } },
        { id: 'rli', label: 'Team Member Role', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'teamrole' } },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {}, },
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { geo: fjl, exi: fjd } }
  },

  team: {
    service: {
      name: 'team',
      title: 'Team',
      key: 'rid',
      num: false,
      fields: ['rid', 'nam', 'shc', 'dsc', 'svc', 'sts', 'ast', 'stp'],
      params: { nam: 'Name', shc: 'Code', dsc: 'Description', svc: 'Service Code', sts: 'Status' },
      grid: [['nam', 'Name'], ['shc', 'Code'], ['dsc', 'Description'], ['dcd', 'Date Created'], ['sts', 'Status'], ['stp', 'Stamp']],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' }, { t: 'Code', v: 'shc' }], def: 'nam' },
      eform: [{ id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'dcd', label: 'Date Created', type: 'df', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }
  },


  directive: {
    service: {
      name: 'directive',
      title: 'Recommendation',
      num: false,
      fields: ['rid', 'nam', 'shc', 'dsc', 'vti', 'vtn', 'vtc', 'ord', 'exi', 'sts', 'ast', 'stp'],
      params: { nam: 'Name', shc: 'Code', dsc: 'Description', vti: 'Type', sts: 'Status' },

      grid: [['ttl', 'Title'], ['rfn', 'Reference'], ['dts', 'Details'], ['fdt', 'Finding'], ['isn', 'Issuer'], ['atn', 'Authoriser'], ['isd', 'Issued'], ['ded', 'Deadline']],
      bar: { pag: true, btn: ['view'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' }, { t: 'Code', v: 'shc' }], def: 'nam' },
      eform: [{ id: 'ttl', label: 'Title', type: 'tf', req: 1, ops: {} },
        { id: 'dts', label: 'Details', type: 'ta', req: 0, ops: {} },
        { id: 'fdi', label: 'Finding', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'finding' } },
        { id: 'isi', label: 'Issuer', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'issuer' } },
        { id: 'ati', label: 'Authoriser', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'authoriser' } },
        { id: 'isd', label: 'Issued', type: 'df', req: 1, ops: {} },
        { id: 'ded', label: 'Deadline', type: 'df', req: 1, ops: {} },
        { id: 'nts', label: 'Notes', type: 'ta', req: 0, ops: {} },
        { id: 'dsi', label: 'State', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'directivestate' } },
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { exi: fjd } }
  },

  declaration: {
    service: {
      name: 'declaration',
      title: 'Declaration',
      num: false,
      fields: ['rid', 'dbi', 'dcd', 'act', 'ent', 'fld', 'rec', 'uid', 'nam', 'cmi', 'chn', 'mbn', 'unm', 'cha', 'ami', 'amc', 'usi', 'sts', 'ast', 'stp'],
      grid: [['rky', 'Ref Key'], ['enc', 'Entity'], ['sdt', 'Start Date'], ['edt', 'End Date'], ['vdt', 'Value Date'], ['amt', 'Amount'], ['sub', 'Submitter']],
      menu: { mnu: [{ t: 'Auditee', v: 'usi' }], def: 'usi' },
      eform: [
        { id: 'eni', label: 'Entity', type: 'fa', col: 1, req: 1, ops: {}, cp: { t: 'bcs', s: 'entity' } },
        { id: 'sdt', label: 'Start Date', type: 'df', col: 1, req: 1, ops: {} },
        { id: 'edt', label: 'End Date', type: 'df', col: 1, req: 1, ops: {} },
        { id: 'vdt', label: 'Value Date', type: 'df', col: 1, req: 1, ops: {} },
        { id: 'amt', label: 'Amount', type: 'nf', col: 1, req: 1, ops: {} },
        { id: 'rfc', label: 'Reference', type: 'tf', col: 1, req: 0, ops: {} },
        { id: 'sub', label: 'Submitter', type: 'tf', col: 1, req: 1, ops: {} },
        { id: 'sti', label: 'Declarative Status', type: 'fa', col: 1, req: 1, ops: {}, cp: { t: 'bcs', s: 'declarationstate' } },
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }
    //formatters: {grid: {req:fjd,res:fjd,exi:fjd}}
  },

  feeaudit: {
    service: {
      name: 'feeaudit',
      title: 'Fee Audit',
      num: true,
      fields: ['rid', 'tri', 'vno', 'dvi', 'dvn', 'dvc', 'eni', 'enc', 'loi', 'geo', 'dcd', 'exi', 'sts', 'ast', 'stp'],
      grid: [['rfn', 'Ref'], ['dck', 'Declaration'], ['amt', 'Amount'], ['dif', 'Difference'], ['vfn', 'Verifier'], ['vfd', 'Verified'], ['sts', 'Status'], ['stp', 'Stamp']],
      menu: { mnu: [{ t: 'Name', v: 'nam' }, { t: 'Code', v: 'shc' }], def: 'nam' },
      eform: [
        { id: 'dci', label: 'Declaration', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'declaration' } },
        { id: 'amt', label: 'Amount', type: 'nf', req: 1, ops: {} },
        { id: 'dif', label: 'Difference', type: 'nf', req: 1, ops: {} },
        { id: 'vfi', label: 'Verifier', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'inspector' } },
        { id: 'vfd', label: 'Verified Date', type: 'df', req: 1, ops: {} },
        { id: 'nts', label: 'Notes', type: 'tf', req: 0, ops: {} },
        { id: 'exi', label: 'Extrainfo', type: 'jf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'fa', req: 0, ops: {}, cp: { t: 'lcs', s: 'status' } },
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' },
    formatters: { grid: { req: fjd, res: fjd, exi: fjd } }
  },

  inspectionfile: {
    service: {
      name: 'inspectionfile',
      title: 'Monitoring File',
      num: true,
      fields: ['rid', 'tri', 'sen', 'rcp', 'msg', 'nti', 'ntc', 'nsi', 'nsc', 'rqi', 'rfn', 'rvi', 'rvd', 'dsc', 'dcd', 'exi', 'usi', 'sts', 'ast', 'stp'],
      grid: [['inc', 'Monitoring'], ['dsc', 'Description'], ['fin', 'File'], ['sts', 'status'], ['stp', 'Stamp']],
      menu: { mnu: [{ t: 'Auditee', v: 'usi' }], def: 'usi' },
      eform: [
        { id: 'tri', label: 'Track ID', type: 'rf', req: 0, ops: {} },
        { id: 'sen', label: 'Sender', type: 'rf', req: 0, ops: {} },
        { id: 'rcp', label: 'Recipient', type: 'rf', req: 0, ops: {} },
        { id: 'msg', label: 'Message', type: 'rf', req: 0, ops: {} },
        { id: 'ntc', label: 'Type', type: 'rf', req: 0, ops: {} },
        { id: 'nsc', label: 'State', type: 'rf', req: 0, ops: {} },
        { id: 'rfn', label: 'Request', type: 'rf', req: 0, ops: {} },
        { id: 'rvd', label: 'Review', type: 'rf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'rf', req: 0, ops: {} },
        { id: 'dcd', label: 'Created', type: 'rf', req: 0, ops: {} },
        { id: 'exi', label: 'Extrainfo', type: 'rf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'rf', req: 0, ops: {} },
        { id: 'stp', label: 'Stamp', type: 'rf', req: 0, ops: {} }
      ],
    },
    create: false,
    actions: { add: 'Add', edit: 'Edit', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }
    //formatters: {grid: {req:fjd,res:fjd,exi:fjd}}
  },

  //   activity
  // customer
  // device
  // event
  //logger
  //notification
  //register
  //request
  //review

  findingfile: {
    //fieldTypes: {tf:'',ta:'',nf:'',df:'',cf:'',rf:'',cb:'',fa:'',rb:'',if:'',ff:''},
    service: {
      name: 'findingfile',
      title: 'Finding File',
      key: 'rid',
      num: false,
      fields: ['rid', 'tri', 'rqi', 'rfn', 'csi', 'csn', 'idn', 'eni', 'enm', 'enc',
        'aci', 'acn', 'acc', 'rti', 'rtn', 'rtc', 'rsi', 'rsn', 'rsc', 'evi',
        'evn', 'evc', 'vti', 'vtn', 'vtc', 'vno', 'vsi', 'vsn', 'vsc', 'dsc', 'dcd',
        'exi', 'nts', 'sts', 'ast', 'stp'],
      grid: [['ttl', 'Title'], ['fin', 'File'], ['dsc', 'Description'], ['dcd', 'Created Date'], ['sts', 'Status'], ['stp', 'Stamp']],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' }, { t: 'Code', v: 'shc' }], def: 'nam' },
      //			paramsadd:':rfn,:tdt,:aai,:xti,:tci,:csi,:dsc,:xsi,:rst,:exi,:dtl',

      eform: [
        { id: 'dcd', label: 'Date', type: 'rf', req: 0, ops: {} },
        { id: 'tri', label: 'Track ID', type: 'rf', req: 0, ops: {} },
        { id: 'rfn', label: 'Request', type: 'rf', req: 0, ops: {} },
        { id: 'csn', label: 'Customer', type: 'rf', req: 0, ops: {} },
        //{id:'idn',label:'Message',type:'rf',req:0,ops:{}},
        { id: 'enm', label: 'Entity', type: 'rf', req: 0, ops: {} },
        { id: 'acn', label: 'Activity', type: 'rf', req: 0, ops: {} },
        //{id:'rtn',label:'Request',type:'rf',req:0,ops:{}},
        { id: 'rsn', label: 'Request State', type: 'rf', req: 0, ops: {} },
        { id: 'evn', label: 'Event', type: 'rf', req: 0, ops: {} },
        { id: 'vtn', label: 'Type', type: 'rf', req: 0, ops: {} },
        { id: 'vsn', label: 'State', type: 'rf', req: 0, ops: {} },
        { id: 'dsc', label: 'Description', type: 'rf', req: 0, ops: {} },
        { id: 'exi', label: 'Extrainfo', type: 'rf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'rf', req: 0, ops: {} },
        { id: 'stp', label: 'Stamp', type: 'rf', req: 0, ops: {} }
      ],
    },
    create: false,
    actions: { add: 'Add', edit: 'Edit', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }
  },

  directivefile: {
    service: {
      name: 'directivefile',
      title: 'Recommendation File',
      num: true,
      fields: ['rid', 'rfn', 'csi', 'csn', 'idn', 'eni', 'enm', 'enc',
        'aci', 'acn', 'acc', 'rti', 'rtn', 'rtc', 'rsi', 'rsn', 'rsc', 'dsc', 'dcd',
        'exi', 'nts', 'sts', 'ast', 'stp'],
      grid: [['ttl', 'Title'], ['rfn', 'Reference'], ['fin', 'File'], ['dsc', 'Description'], ['sts', 'Status'], ['stp', 'Stamp']],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' }, { t: 'Code', v: 'shc' }], def: 'nam' },
      //			paramsadd:':rfn,:tdt,:aai,:xti,:tci,:csi,:dsc,:xsi,:rst,:exi,:dtl',

      eform: [
        { id: 'dcd', label: 'Date', type: 'rf', req: 0, ops: {} },
        //{id:'tri',label:'Track ID',type:'rf',req:0,ops:{}},
        { id: 'rfn', label: 'Request', type: 'rf', req: 0, ops: {} },
        { id: 'csn', label: 'Customer', type: 'rf', req: 0, ops: {} },
        //{id:'idn',label:'Message',type:'rf',req:0,ops:{}},
        { id: 'enm', label: 'Entity', type: 'rf', req: 0, ops: {} },
        { id: 'acn', label: 'Activity', type: 'rf', req: 0, ops: {} },
        { id: 'rtn', label: 'Type', type: 'rf', req: 0, ops: {} },
        { id: 'rsn', label: 'State', type: 'rf', req: 0, ops: {} },
        //{id:'evn',label:'Event',type:'rf',req:0,ops:{}},
        //{id:'vtn',label:'Type',type:'rf',req:0,ops:{}},
        //{id:'vsn',label:'State',type:'rf',req:0,ops:{}},
        { id: 'dsc', label: 'Description', type: 'rf', req: 0, ops: {} },
        { id: 'exi', label: 'Extrainfo', type: 'rf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'rf', req: 0, ops: {} },
        { id: 'stp', label: 'Stamp', type: 'rf', req: 0, ops: {} }
      ],
    },
    create: false,
    panels: {
      //edit:'simple',view:'result',close:'dialog',check:'dialog',print:'result'
      view: 'simple', close: 'dialog', check: 'dialog', print: 'result'
    },
    formatters: {
      grid: { rbo: fjd, rin: fjd, exi: fjd }
    }
  },

  monitoringfile: {
    service: {
      name: 'monitoringfile',
      title: 'Monitoring File',
      num: true,
      fields: ['rid', 'rfn', 'csi', 'csn', 'idn', 'eni', 'enm', 'enc',
        'aci', 'acn', 'acc', 'rti', 'rtn', 'rtc', 'rsi', 'rsn', 'rsc', 'dsc', 'dcd',
        'exi', 'nts', 'sts', 'ast', 'stp'],
      grid: [['ttl', 'Title'], ['rfn', 'Reference'], ['fin', 'File'], ['dsc', 'Description'], ['sts', 'Status'], ['stp', 'Stamp']],
      bar: { pag: true, btn: ['add', 'edit', 'del', 'view', 'man', 'wiz'] },
      menu: { mnu: [{ t: 'Name', v: 'nam' }, { t: 'Code', v: 'shc' }], def: 'nam' },
      //			paramsadd:':rfn,:tdt,:aai,:xti,:tci,:csi,:dsc,:xsi,:rst,:exi,:dtl',

      eform: [
        { id: 'dcd', label: 'Date', type: 'rf', req: 0, ops: {} },
        //{id:'tri',label:'Track ID',type:'rf',req:0,ops:{}},
        { id: 'rfn', label: 'Request', type: 'rf', req: 0, ops: {} },
        { id: 'csn', label: 'Customer', type: 'rf', req: 0, ops: {} },
        //{id:'idn',label:'Message',type:'rf',req:0,ops:{}},
        { id: 'enm', label: 'Entity', type: 'rf', req: 0, ops: {} },
        { id: 'acn', label: 'Activity', type: 'rf', req: 0, ops: {} },
        { id: 'rtn', label: 'Type', type: 'rf', req: 0, ops: {} },
        { id: 'rsn', label: 'State', type: 'rf', req: 0, ops: {} },
        //{id:'evn',label:'Event',type:'rf',req:0,ops:{}},
        //{id:'vtn',label:'Type',type:'rf',req:0,ops:{}},
        //{id:'vsn',label:'State',type:'rf',req:0,ops:{}},
        { id: 'dsc', label: 'Description', type: 'rf', req: 0, ops: {} },
        { id: 'exi', label: 'Extrainfo', type: 'rf', req: 0, ops: {} },
        { id: 'sts', label: 'Status', type: 'rf', req: 0, ops: {} },
        { id: 'stp', label: 'Stamp', type: 'rf', req: 0, ops: {} }
      ],
    },
    create: false,
    panels: {
      //edit:'simple',view:'result',close:'dialog',check:'dialog',print:'result'
      view: 'simple', close: 'dialog', check: 'dialog', print: 'result'
    },
    formatters: {
      grid: { rbo: fjd, rin: fjd, exi: fjd }
    }
  },

};
